import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p3_high_budget archetype (real metrics, fake identity).
export const bAdvP3HighBudget: FaireBrandEntity = {
  token: "b_adv_p3_high_budget",
  type: "brand",
  name: "Ember & Ash",
  description: "Hand-poured candles, incense, and natural fragrance",
  location: "Santa Fe, NM",
  rating: 4.9,
  minimumOrderDollars: 150,
  tags: ["candles", "fragrance", "home"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
